import React from 'react';

import Stack from '@mui/material/Stack';

import RoleChip from 'components/chip/RoleChip';

import GuideInfoBox from '../components/GuideInfoBox';
import GuideMockContainer from '../components/GuideMockContainer';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';
import GuideStepList from '../components/GuideStepList';
import GuideTable from '../components/GuideTable';

const GuideUserRole: React.FC = () => {
  return (
    <GuidePageLayout
      title="ユーザーの権限を変更する"
      description="既存ユーザーに付与されている権限を変更します。"
      breadcrumbs={[{ label: 'ユーザー管理', path: '/guide/user/overview' }]}
    >
      <GuideSection title="前提">
        <GuideTable
          headers={['条件', '内容']}
          rows={[
            ['必要な権限', '管理者'],
            ['ログイン状態', 'ログイン済みであること'],
            ['対象ユーザー', '存在すること'],
          ]}
        />
      </GuideSection>

      <GuideSection title="手順">
        <GuideStepList
          steps={[
            { label: 'ユーザー管理画面を開く' },
            { label: 'ユーザー一覧から対象ユーザーを選択する' },
            {
              label: '権限セクションでロールChipをクリックして権限を切り替える',
              description:
                '塗りつぶし状態が付与済み、アウトライン状態が未付与です。クリックするたびに即時保存されます。',
              content: (
                <GuideMockContainer label="権限（クリックで切替）">
                  <Stack
                    direction="row"
                    spacing={1}
                    flexWrap="wrap"
                    useFlexGap
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      bgcolor: 'action.hover',
                      border: 1,
                      borderColor: 'divider',
                      pointerEvents: 'none',
                    }}
                  >
                    <RoleChip role="ADMIN" variant="filled" />
                    <RoleChip role="BACK_OFFICE" variant="filled" />
                    <RoleChip role="MANAGER" variant="outlined" />
                  </Stack>
                </GuideMockContainer>
              ),
            },
          ]}
        />
      </GuideSection>

      <GuideSection title="入力項目">
        <GuideTable
          headers={['項目名', '必須', '形式', '備考']}
          rows={[
            [
              '権限',
              '必須（1つ以上）',
              'ロールChipクリック切替',
              '管理者 / 管理部門 / 課長 から選択',
            ],
          ]}
        />
      </GuideSection>

      <GuideSection title="注意事項">
        <Stack spacing={1}>
          <GuideInfoBox type="warning">
            権限は洗い替え方式です。保存時に選択されている権限がそのユーザーの全権限となります。
          </GuideInfoBox>
          <GuideInfoBox>最低1つの権限を選択する必要があります。</GuideInfoBox>
          <GuideInfoBox type="warning">
            自分自身の管理者権限を外す場合、管理機能にアクセスできなくなるので注意してください。
          </GuideInfoBox>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideUserRole;
